import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import InviteCode from './components/InviteCode';
import Dashboard from './components/Dashboard';
import LoadingSpinner from './components/LoadingSpinner';
import OfflineIndicator from './components/OfflineIndicator';
import api from './api';

const logoUrl = '/JM Logo.svg'; // Use SVG logo

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      const token = localStorage.getItem('weddingToken');
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        // Test the token by making a request to the photos endpoint
        await api.get('/photos', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Token validation failed:', error);
        // Token is invalid or expired, remove it and redirect to login
        localStorage.removeItem('weddingToken');
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    };

    validateToken();
  }, []);

  if (isLoading) {
    return <LoadingSpinner logo={logoUrl} />;
  }

  return (
    <>
      <OfflineIndicator />
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <InviteCode setAuth={setIsAuthenticated} logo={logoUrl} />} />
          <Route path="/dashboard/*" element={isAuthenticated ? <Dashboard logo={logoUrl} /> : <Navigate to="/" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;